import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

export function initSetry() {
    Sentry.init({
        dsn: "https://621909a2255c44d4ac2cdbaf183928c9@o1283582.ingest.sentry.io/6493712",
        integrations: [new BrowserTracing()],
      
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
      });
}

export function captureBreadCrumb({ message, category = "general", data ={} }) {
    try {
        Sentry.addBreadcrumb({
            message,
            category,
            data
        })
    } catch {
        // noop
    }
}

export function captureError(error) {
    try {
        Sentry.captureException(error);
    } catch (error) {
        console.log(error);
    }
}